import { MdOutlineNavigateNext, MdOutlineNavigateBefore } from "react-icons/md";
import { Box, IconButton, Skeleton } from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import MenuItem from "@mui/material/MenuItem";
import { useQuery } from "react-query";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";

import Image from "../../components/Image/Image";
import "./ShowPage.css";
import UnitsSelection from "../../components/UnitsSelection";
import ReactAudioPlayer from "react-audio-player";
import Header from "../../panel/Header";
import { GiSpeaker } from "react-icons/gi";
import useIsSmallScreen from "../../utils/useIsSmallScreen";

const ShowPage = () => {
  const IS_SMALL_SCREEN = useIsSmallScreen();

  const { unitId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [audioSrc, setAudioSrc] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPage, setSelectedPage] = useState();
  const [smallScreenPageIndex, setSmallScreenPageIndex] = useState(0);
  const [selectedPageIndex, setSelectedPageIndex] = useState(0);
  const [replayAudio, setReplayAudio] = useState(0);
  const open = Boolean(anchorEl);

  const {
    data: unit,
    error: errorUnit,
    isFetching: isLoadingUnit,
  } = useQuery(`api/units/${unitId}`);

  const {
    data: allUnits,
    error: errorAllUnits,
    isFetching: isLoadingAllUnit,
  } = useQuery(unit?.unit?.bookId && `api/unit?bookId=${unit?.unit.bookId}`);

  const {
    status: allPagesStatus,
    data: allPages,
    isFetching: isLoadingPages,
  } = useQuery(`api/page?unitId=${unitId}`);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const nextIsDisable = useMemo(
    () =>
      IS_SMALL_SCREEN
        ? smallScreenPageIndex === 1 &&
          allPages?.pages?.length - 1 === selectedPageIndex
        : allPages?.pages?.length - 1 === selectedPageIndex,
    [
      IS_SMALL_SCREEN,
      allPages?.pages?.length,
      selectedPageIndex,
      smallScreenPageIndex,
    ]
  );

  function checkEndOfBook() {
    // eslint-disable-next-line eqeqeq
    if (allUnits?.units?.[allUnits?.units?.length - 1]?.id == unitId) {
      return nextIsDisable;
    }
    return false;
  }

  const handleBackBtn = () => {
    navigate(`/units/${unitId}`);
  };

  function playAudio(audio_url) {
    console.log("play button");
    setAudioSrc(audio_url);
    setReplayAudio((p) => p + 1);
  }

  useEffect(() => {
    if (allPagesStatus === "success") {
      if (state) {
        const { pageId } = state;
        let tempPageIndex = allPages?.pages?.findIndex((page) => {
          if (page.id === pageId) return true;
          return false;
        });
        setSelectedPage(allPages?.pages?.[tempPageIndex]);
        setSelectedPageIndex(tempPageIndex);
      } else {
        setSelectedPage(allPages?.pages?.[0]);
      }
    }
  }, [allPages, allPagesStatus, state]);

  return (
    <div className="pageContainer md-showPages">
      <Header
        onBack={handleBackBtn}
        extra={
          isLoadingAllUnit ? (
            <Skeleton width={100} height={40} />
          ) : (
            <UnitsSelection unit={unit} handleClick={handleClick} />
          )
        }
        title={"Live The Language!"}
        playbarSection={
          audioSrc && (
            <>
              {IS_SMALL_SCREEN ? (
                <Box component="div" sx={SMALL_SCREEN_PALYBAR_STYLE}>
                  <ReactAudioPlayer
                    key={replayAudio}
                    src={audioSrc}
                    autoPlay
                    controls
                    style={{ display: audioSrc ? "block" : "none" }}
                  />
                </Box>
              ) : (
                <ReactAudioPlayer
                  key={replayAudio}
                  src={audioSrc}
                  autoPlay
                  controls
                  style={{
                    display: audioSrc ? "block" : "none",
                    marginRight: "16px",
                  }}
                />
              )}
            </>
          )
        }
        isSmallScreen={IS_SMALL_SCREEN}
      />

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {allUnits?.units?.map((unit) => (
          <MenuItem
            key={unit.id}
            onClick={() => {
              navigate(`/show/${unit.id}`);
              setSelectedPageIndex(0);
              setSmallScreenPageIndex(0);
              setAudioSrc();
              handleClose();
            }}
          >
            <Box
              component="span"
              className="md-menuUnit"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {unit.title}
              <Box
                component="span"
                sx={{ ml: 1, display: "flex", alignItems: "center" }}
              >
                <GiSpeaker />
                {unit.totalAudio}
              </Box>
            </Box>
          </MenuItem>
        ))}
      </Menu>

      <div className="mainContent">
        <div className="imageSlider">
          <IconButton
            id="prev"
            className="arrowBtn"
            onClick={() => {
              if (IS_SMALL_SCREEN && smallScreenPageIndex === 1) {
                setSmallScreenPageIndex(0);
              } else {
                setSmallScreenPageIndex((prev) => (prev === 0 ? 1 : 0));
                setSelectedPage(allPages?.pages?.[selectedPageIndex - 1]);
                setSelectedPageIndex((prev) => prev - 1);
              }
            }}
            disabled={
              IS_SMALL_SCREEN
                ? smallScreenPageIndex === 0 && selectedPageIndex === 0
                : selectedPageIndex === 0
            }
          >
            <Icon className="arrowBtn__icon">
              <MdOutlineNavigateBefore className="arrowBtn__icon--svg" />
            </Icon>
          </IconButton>

          <div className="pageImg">
            {selectedPage?.images?.map((image, i) => {
              if (IS_SMALL_SCREEN) {
                if (i === smallScreenPageIndex) {
                  return (
                    <Image
                      isSmalllScreen={true}
                      image={image}
                      playAudio={playAudio}
                      isLeft={i % 2 === 0}
                      key={image.id}
                      unitId={unitId}
                    />
                  );
                }
                return null;
              }
              return (
                <Image
                  key={image.id}
                  image={image}
                  playAudio={playAudio}
                  isLeft={i % 2 === 0}
                  unitId={unitId}
                />
              );
            })}
          </div>

          <IconButton
            sx={{ position: "relative" }}
            id="next"
            className={`arrowBtn ${nextIsDisable ? "" : "enable"}`}
            onClick={() => {
              if (IS_SMALL_SCREEN && smallScreenPageIndex === 0) {
                setSmallScreenPageIndex(1);
              } else {
                setSmallScreenPageIndex((prev) => (prev === 0 ? 1 : 0));
                setSelectedPage(allPages?.pages?.[selectedPageIndex + 1]);
                setSelectedPageIndex((prev) => prev + 1);
              }
            }}
            disabled={nextIsDisable}
          >
            <Icon className="arrowBtn__icon">
              <MdOutlineNavigateNext className="arrowBtn__icon--svg" />
            </Icon>
            {checkEndOfBook() && <p className="theEndTag">The End</p>}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default ShowPage;

const SMALL_SCREEN_PALYBAR_STYLE = {
  position: "sticky",
  width: "100%",
  bottom: "0px",
  left: "0px",
  zIndex: "300",
  "&>audio": {
    width: "100%",
  },
};
